import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-highlights-and-trends',
  templateUrl: './highlights-and-trends.component.html',
  styleUrls: ['./highlights-and-trends.component.scss']
})
export class HighlightsAndTrendsComponent implements OnInit {
  @Input() highlights!: any;

  constructor() { }

  ngOnInit(): void {
  }

}
